import { useTranslation } from "react-i18next";
import DateTimePicker from "@/src/components/atoms/DateTimePicker/DateTimePicker";
import { FormControl, FormHelperText, Stack, Typography } from "@mui/material";
import { type FieldErrors } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";

export interface RevokeAtPropsType {
    onChange: (date: string | undefined) => void;
    errors: FieldErrors;
}

export const RevokeAt = ({ onChange, errors }: RevokeAtPropsType) => {
    const { t } = useTranslation();

    return (
        <Stack direction="column" gap={1}>
            <Stack direction="row" alignItems="center" gap={2}>
                <Typography
                    component="dt"
                    fontWeight="bold"
                    sx={{
                        width: "150px",
                        flexShrink: 0,
                    }}
                >
                    {t("validated-question-create.date.label-revoke-at")}:
                </Typography>
                <FormControl
                    fullWidth
                    sx={{
                        flex: "1",
                    }}
                >
                    <DateTimePicker
                        views={["year", "month", "day", "hours"]}
                        defaultValue={null}
                        onChange={(value: Date | null) => {
                            if (value) {
                                onChange(value.toString());
                            } else {
                                onChange(undefined);
                            }
                        }}
                    />
                </FormControl>
            </Stack>
            <FormHelperText>
                <ErrorMessage errors={errors} name="revokeAt" />
            </FormHelperText>
        </Stack>
    );
};

export default RevokeAt;
